import { render, staticRenderFns } from "./OrientationTip.vue?vue&type=template&id=d7dbcfaa&scoped=true"
import script from "./OrientationTip.vue?vue&type=script&lang=js"
export * from "./OrientationTip.vue?vue&type=script&lang=js"
import style0 from "./OrientationTip.vue?vue&type=style&index=0&id=d7dbcfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dbcfaa",
  null
  
)

export default component.exports